/* eslint-disable react/prop-types */
import { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  OutlinedInput,
} from '@mui/material';

const useStyles = makeStyles(
  {
    group: {
      borderBottom: '1px solid #dcdc',
    },
  },
  { name: 'BringerSelect' }
);

export default function BingerSelect({
  onChange: _onChange,
  disabled,
  input: { name, onChange, value },

  // inputInput,
  variant,

  helperText,
  meta,
  label,
  options,
  required,
  _multiple,
  size,
  emptyLabel = 'No Options',
}: any) {
  const classes = useStyles();
  const [_value, setValue] = useState(value);
  const inputLabel = useRef(null);

  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleChange = (event: any) => {
    setValue(event.target.value);
    onChange(event.target.value);
    if (_onChange) {
      _onChange(event.target.value);
    }
  };

  const showEmptyOption = !options || !options.length;

  const extraProps =
    variant === 'outlined'
      ? // @ts-expect-error ts-migrate(2322) FIXME: Type '{ labelWidth: number; name: any; id: any; }'... Remove this comment to see the full error message
        { input: <OutlinedInput labelWidth={labelWidth} name={name} id={name} /> }
      : {};

  return (
    <FormControl
      size={size}
      required={required}
      error={meta.error && meta.touched}
      variant={variant}
      fullWidth
      disabled={disabled}
    >
      <InputLabel ref={inputLabel} htmlFor={name}>
        {label}
      </InputLabel>
      <Select
        {...extraProps}
        fullWidth
        value={_value}
        onChange={handleChange}
        inputProps={{
          name,
          id: name,
        }}
        multiple={_multiple}
      >
        {showEmptyOption && <MenuItem disabled>{emptyLabel}</MenuItem>}
        {options &&
          options.map((opt: any) => {
            const attribs = opt.isGroup ? { disabled: true, className: classes.group } : {};
            let isSelected = opt.value === _value;
            if (Array.isArray(_value)) {
              isSelected = _value.some((item) => item === opt.value);
            }

            return (
              <MenuItem
                key={`${name}-${JSON.stringify(opt.value)}`}
                selected={isSelected}
                {...attribs}
                value={opt.value}
              >
                {opt.label}
              </MenuItem>
            );
          })}
      </Select>
      {(meta.touched || !!helperText) && (
        <FormHelperText>{meta.error || helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
